module.exports = __webpack_public_path__ + "assets/images/sample_d5d61ae0b0b70200d1156fafd593a407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-2/sample.png
// module id = 256
// module chunks = 0